import { render, staticRenderFns } from "./CounselModal.vue?vue&type=template&id=45f31667&scoped=true&"
import script from "./CounselModal.vue?vue&type=script&lang=js&"
export * from "./CounselModal.vue?vue&type=script&lang=js&"
import style0 from "./CounselModal.vue?vue&type=style&index=0&id=45f31667&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f31667",
  null
  
)

export default component.exports